import { formatCurrencyShort } from '../../lib/format.js';
import { actualColorClass, forecastColorClass } from './CellPair.jsx';

const TONE = {
  // Ligne de catégorie : couleurs selon le sens du flux, comme les cellules du mois.
  category: (actual, forecast, flowType) => ({
    actual:   `text-[11px] py-1 font-semibold ${actualColorClass(actual, flowType)}`,
    forecast: `text-[11px] py-1 italic ${forecastColorClass(forecast, flowType)}`,
  }),
  // Solde intermédiaire, ligne « Total » de section (discrète).
  section: () => ({
    actual:   'text-[10px] pt-1.5 pb-0 text-slate-500',
    forecast: 'text-[10px] pt-1.5 pb-0 italic text-slate-500',
  }),
  // Solde intermédiaire, ligne cumul (valeur principale).
  cumul: () => ({
    actual:   'text-[11px] pt-0 pb-1.5 font-semibold text-slate-800',
    forecast: 'text-[11px] pt-0 pb-1.5 italic font-semibold text-slate-700',
  }),
  // Lignes fixes (à catégoriser, TVA) : couleur fournie par l'appelant.
  plain: (_a, _f, _ft, extra) => ({
    actual:   `text-xs py-1.5 font-medium ${extra ?? 'text-slate-700'}`,
    forecast: `text-xs py-1.5 italic ${extra ?? 'text-slate-500'}`,
  }),
};

/**
 * Paire de <td> « Total » (Réel | Prévi) en fin de ligne, sommes sur la période affichée.
 * Non cliquable. Fond neutre et liseré gauche pour se distinguer des mois.
 *
 * Props :
 *   actual, forecast  number | null
 *   tone              'category' | 'section' | 'cumul' | 'plain'
 *   flowType          'income' | 'expense' | 'neutral'  (tone=category)
 *   colorClass        classes couleur (tone=plain)
 */
export default function TotalCells({ actual, forecast, tone = 'category', flowType = 'expense', colorClass }) {
  const cls = TONE[tone](actual, forecast, flowType, colorClass);
  const base = 'min-w-[96px] px-2 tabular-nums text-right align-middle whitespace-nowrap bg-slate-50';
  return (
    <>
      <td className={`${base} border-l-2 border-slate-300 border-r border-slate-100 ${cls.actual}`} title="Total Réel — période affichée">
        {actual != null ? formatCurrencyShort(actual) : '—'}
      </td>
      <td className={`${base} ${cls.forecast}`} title="Total Prévisionnel — période affichée">
        {forecast != null ? formatCurrencyShort(forecast) : '—'}
      </td>
    </>
  );
}
